import { render } from "./ImageForm.vue?vue&type=template&id=8ca91d1e&scoped=true"
import script from "./ImageForm.vue?vue&type=script&lang=js"
export * from "./ImageForm.vue?vue&type=script&lang=js"

import "./ImageForm.vue?vue&type=style&index=0&id=8ca91d1e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca91d1e"]])

export default __exports__